import React from "react";
import { Col, Container, Row, Tabs, Tab } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

const Technologygcc = () => {
  return (
    <div
      className="tabing_section healthcare_tabs_sec cloud_computing_tabs p-100"
      style={{ background: "#F8F8FB" }}
    >
      <Container>
        <Row>
          <Col xs={12} md={9} lg={8} className="m-auto text-center">
            <h3 className="h3_head">
              Core Competencies of Our Android Development Team
            </h3>
          </Col>
        </Row>
        <Row>
          <Tabs defaultActiveKey="1" id="uncontrolled-tab-example">
            <Tab eventKey="1" title="Languages">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/healthcare-new/language/java.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Java</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/healthcare-new/language/vector.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Kotlin</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="2" title="Frameworks & Libraries">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/android-new/frameworks/jetpack_compose.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Jetpack</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/hire_android/frameworks/Dagger.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Dagger</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/android-new/library/rxjava.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Rxjava</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/hire_android/frameworks/Glide.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Glide</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/hire_android/frameworks/Retrofit.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Retrofit</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="3" title="Testing Tools">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/hire_android/testing/Firebase_Test_Lab.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Firebase Test Lab</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/hire_android/testing/JUnit.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>JUnit</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/hire_android/testing/Robolectric.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Robolectric</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="4" title="CI/CD Tools">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/hire_android/ci_cd/Android_Studio.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Android Studio</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/hire_android/ci_cd/Gradle.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Gradle</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/hire-ios-app-developers/build_cicl/Bitrise.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Bitrise</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/hire-ios-app-developers/build_cicl/CircleCI.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>CircleCI</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/hire-ios-app-developers/build_cicl/Jenkins.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Jenkins</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="5" title="Monitoring Tools">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/hire-ios-app-developers/app_monitoring/Firebase_Crashlytics.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Firebase Crashlytics</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/hire-ios-app-developers/app_monitoring/Instabug.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Instabug</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/hire-ios-app-developers/app_monitoring/New_Relic.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>New Relic</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="6" title="Databases">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/hire-ios-app-developers/database/Firebase_Database.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Firebase Database </h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/hire-ios-app-developers/database/SQLite.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>SQLite</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="7" title="APIs & Integrations">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/hire_android/api/Firebase_Cloud_Messaging.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Firebase Cloud Messaging</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/hire-ios-app-developers/api/GraphQL.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>GraphQL</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/hire-ios-app-developers/api/RESTful_APIs.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Restful APIs</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/hire_android/api/Google_Pay.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Google Pay</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/hire_android/api/Stripe.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Stripe</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="8" title="Cloud Services">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/cloud-new/cloud_platforms/aws.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={86}
                    height={86}
                  />
                  <div className="text_tabs_web">
                    <h6>AWS</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/cloud-new/cloud_platforms/azure.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={86}
                    height={86}
                  />
                  <div className="text_tabs_web">
                    <h6>Azure</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/cloud-new/cloud_platforms/google_cloud.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={86}
                    height={86}
                  />
                  <div className="text_tabs_web">
                    <h6>Google Cloud</h6>
                  </div>
                </li>
              </ul>
            </Tab>
          </Tabs>
        </Row>
      </Container>
    </div>
  );
};

export default Technologygcc;
